import redirectInterceptor from "@/interceptors/redirect_interceptor";

export class CiiService {
  constructor(baseUrl, ciiRatingsMapper, ciiContributionValuesMapper, currentCiiMapper, ciiVoyageDataMapper, calculationResultMapper) {
    this.baseUrl = baseUrl;
    this.ciiRatingsMapper = ciiRatingsMapper;
    this.ciiContributionValuesMapper = ciiContributionValuesMapper;
    this.currentCiiMapper = currentCiiMapper;
    this.ciiVoyageDataMapper = ciiVoyageDataMapper;
    this.calculationResultMapper = calculationResultMapper;
  }

  async getCiiRatings(accessToken, vesselName, year) {
    try {

      const response = await redirectInterceptor.get(`${this.baseUrl}/cii/${vesselName}/ratings/${year}`, {
        headers: {
          "Authorization": `${accessToken}`
        }
      });

      return this.ciiRatingsMapper(response.data);
    } catch (error) {
      throw error;
    }
  }

  async getAllCiiRatings(accessToken) {
    const response = await redirectInterceptor.get(`${this.baseUrl}/cii/ratings/`, {
      headers: { "Authorization": `${accessToken}` }
    });

    return this.ciiRatingsMapper(response.data);
  }

  async getCiiContributionValues(accessToken, vesselName, date) {
    try {
      const response = await redirectInterceptor.get(`${this.baseUrl}/cii/${vesselName}/contribution-values/${date}`, {
        headers: {
          "Authorization": `${accessToken}`
        }
      });
      return this.ciiContributionValuesMapper(response.data);
    } catch (error) {
      throw error;
    }
  }

  async getCiiHistory(accessToken, vesselName, startDate, endDate) {
    try {
      const response = await redirectInterceptor.get(`${this.baseUrl}/cii/${vesselName}/history/${startDate}/${endDate}`, {
        headers: {
          "Authorization": `${accessToken}`
        }
      });
      return response.data.map((datum) => this.currentCiiMapper(datum));
    } catch (error) {
      throw error;
    }
  }

  async getVoyageDataForCiiHistory(accessToken, vesselName, startDate, endDate) {
    try {
      const response = await redirectInterceptor.get(`${this.baseUrl}/cii/${vesselName}/voyage-data-for-cii-history/${startDate}/${endDate}`, {
        headers: {
          "Authorization": `${accessToken}`
        }
      });
      return response.data.map((datum) => this.ciiVoyageDataMapper(datum));
    } catch (error) {
      throw error;
    }
  }

  async calculateCiiContribution(accessToken, vesselName, valuesList) {
    try {
      const request = {
        method: "POST",
        url: `${this.baseUrl}/vesselperformance/vessel/${vesselName}/cii/contribution-user-input/`,
        headers: {
          "Authorization": `${accessToken}`
        },
        data: {
          values: valuesList
        }
      };

      const response = await redirectInterceptor.request(request);
      const parsedJson = JSON.parse(response.data.data.replace(/'/g, "\""));
      return this.calculationResultMapper(parsedJson);
    } catch (error) {
      throw error;
    }
  }
}
